import React, { type PropsWithChildren } from "react";
import { Box, type SpaceProps } from "@chakra-ui/react";
import { HeroSpotlightBackgroundEffects } from "components/hero/spotlight-background-effects";
import { Section, type SectionProps } from "components/section";
import { FadeIn } from "ui/animations";
import { type BrandColor } from "contexts/color-theme";

type GradientHeroProps = {
  /**
   * Color variant to use for the background effects.
   * */
  variant: BrandColor;

  /**
   * The shade to use for the main background color.
   * @default "150"
   */
  shade?: "50" | "150";
} & SpaceProps &
  Pick<SectionProps, "fullWidth">;

export function LightGradientBackground({
  shade = "150",
  variant,
  children,
  fullWidth,
  ...spaceProps
}: PropsWithChildren<GradientHeroProps>) {
  return (
    <Box as="section" pos="relative" overflow="hidden" bg={`new.${variant}.${shade}`} {...spaceProps}>
      <HeroSpotlightBackgroundEffects
        hasBgForHalfHero
        theme="light"
        bgColor={`new.${variant}.${shade}`}
        spotlightColor="white"
      />

      <Section as="div" fullWidth={fullWidth} themeBgColor={`new.${variant}.${shade}`} my="0">
        <FadeIn duration={0.3}>{children}</FadeIn>
      </Section>

      <Section as="div" fullWidth={fullWidth} my="0">
        <Box h={{ base: "biggest", lg: "huge" }} />
      </Section>
    </Box>
  );
}
